import styled from 'styled-components';

export const PopupContent = styled.div`
  font-size: 13px;
  cursor: default;
  padding: 2px 0px;
  background: white;
  min-width: 50px;
  max-height: 1000px;
  border-radius: 5px;
`;

export const PopupInner = styled.div`
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
`;

export const PopupHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  padding: 10px;
  font-weight: 600;
  border-bottom: 1px solid #d7d7d7;
  color: rgba(0, 0, 0, .9);
`;

export const PopupBody = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 100%;
  overflow: hidden;
  max-height: 80vh;
`;

export const PopupSelectContent = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
`;

export const PopupSelect = styled.div`
  width: 90%;
`;

export const PopupListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column nowrap;
  flex: 1 1 100%;
  overflow-y: auto;
`;

export const PickerPopupContainer = styled.div`
  background: #f3f3f3;
  font-size: 13px;
  cursor: default;
  border-radius: 6px;
  position: absolute;
  top: 70px;
  left: -190px;
  max-height: 238px;
  max-width: 800px;
  display: flex;
  flex-flow: column nowrap;
  border: 1px solid #e1e1e1;
`;

export const PickerPopupInner = styled.div`
  padding-top: 20px;
  display: flex;
  flex-flow: column nowrap;
`;

export const PickerPopupModes = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: center;
`;

export const PickerPopupContext = styled.div`
  padding: 16px 4px;
  background: #fff;
  border-top: 1px solid #e1e1e1;
  border-radius: 0 0 6px 6px;
  width: 470px;
`;

export const PickerPopupJumpto = styled.div`
  margin-bottom: 13px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

export const PickerPopupCurrent = styled.div`
  margin: 0 24px;
  width: 150px;
  white-space: nowrap;
  text-align: center;
`;

export const ApplyButton = styled.div`
  margin: 5px;
  background: #172B4D;
  border-radius: 4px;
  height: 39px;
  width: 39px;
  position: relative;
  cursor: pointer;
`;

ApplyButton.displayName = 'ApplyButton';

export const CheckIcon = styled.img`
  width: 20px;
  height: 13px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Separator = styled.div`
  height: 1px;
  background: #b7b7b7;
  width: 10px;
`;

export const PickerPopupButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding-left: 28px;
`;
PickerPopupButtons.displayName = 'PickerPopupButtons';
